import { memo, PropsWithChildren } from 'react'

type Props = {
  to?: string | null
  className?: string
} & PropsWithChildren

export const ExternalLink = memo(({ className, to, children }: Props) => {
  if (!to) {
    return children
  }
  return (
    <a
      className={className}
      href={to}
      target="_blank"
      rel="noopener noreferrer"
    >
      {children}
    </a>
  )
})

ExternalLink.displayName = 'ExternalLink'
